import { mapValues } from 'lodash';
/**
 * Version 10 migrations registration summary widget - products
 * - Adding default configurations for products table
 * - Adding default styling for products table
 */
export default function v10(website) {
  return {
    ...website,
    eventVersion: 10,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'RegistrationSummary' && !layoutItem.config.productsHeader) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            displayAdmissionItems: true,
            displaySessions: true,
            productsHeader: 'EventWidgets_RegistrationSummary_DefaultProductHeader__resx',
            style: {
              ...layoutItem.config.style,
              productTableStyles: {
                productHeaderStyles: {
                  styleMapping: 'text2',
                  customSettings: {
                    background: {
                      color: 'primary'
                    },
                    spacing: {
                      padding: {
                        paddingBottom: 5,
                        paddingTop: 5,
                        paddingLeft: 20,
                        paddingRight: 0
                      }
                    }
                  }
                },
                productTypeStyles: {
                  styleMapping: 'header4',
                  customSettings: {
                    spacing: {
                      padding: {
                        paddingBottom: 0,
                        paddingTop: 0,
                        paddingLeft: 20,
                        paddingRight: 0
                      }
                    }
                  }
                },
                productRowStyles: {
                  styleMapping: 'body1',
                  customSettings: {
                    spacing: {
                      padding: {
                        paddingBottom: 0,
                        paddingTop: 0,
                        paddingLeft: 20,
                        paddingRight: 0
                      }
                    }
                  }
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
